export enum OrderState {
    New,
    Pending,
    Submitted,
    FavoriteOrder,
    EditFavoriteOrder
}
